import { useEffect, useState } from "react"
import { toPrice } from "../../../helpers/stringFormat"

function CurrencySingleValue(props) {
    const [currency, setCurrency] = useState(props.currency || "USD")
    const [currencySymbol, setCurrencySymbol] = useState(props.currencySymbol || "$")
    const [amount, setAmount] = useState(props.amount || 0)
    const [formattedAmount, setFormattedAmount] = useState("$0.00")
    const [toPriceNegPrefix] = useState(props.toPriceNegPrefix)
    const [toPriceNegSuffix] = useState(props.toPriceNegSuffix)
    const [toPricePosPrefix] = useState(props.toPricePosPrefix)

    useEffect(() => {
        if (props.currency !== undefined) setCurrency(props.currency)
        if (props.currencySymbol !== undefined) setCurrencySymbol(props.currencySymbol)
        setAmount(props.amount)
        let formattedAmountString = toPrice(
            amount,
            { 
                negPrefix: toPriceNegPrefix,
                negSuffix: toPriceNegSuffix,
                posPrefix: toPricePosPrefix,
                currencySymbol: currencySymbol 
            }
        )
        if (currency !== "USD") {
            formattedAmountString = `${formattedAmountString} (${currency})`
        }
        setFormattedAmount(formattedAmountString)
    }, [props])

    return (<>{formattedAmount}</>)
}

export default CurrencySingleValue;